import {Component, Input, TemplateRef, ViewChild} from '@angular/core';
import {DataTableComponent} from "../../../../../../../shared/components/data-table/data-table.component";

@Component({
    selector: 'app-details-table',
    templateUrl: './details-table.component.html',
    styleUrls: ['./details-table.component.scss'],
    standalone: false
})
export class DetailsTableComponent {

  @Input() body: TemplateRef<any>;
  @Input() searchTerm: string;

  reset() {
      this.dataTableComponent.reset();
  }

  @ViewChild('dataTable')
      dataTableComponent: DataTableComponent;

  hasRuntimePolicyFeature = false;

  doSearch(st: string) {
      this.searchTerm = st;
  }

}
